export default __webpack_public_path__ + "static/media/CamilaGonzalez.9930be80.png";